import { ISODateString, List } from "@/app/types"

// these are the type definitions for the /meta/terms API response
export class Term {
  isPeriodic: boolean
  interval: string
  key: string
  name: string[]
  asOfDate: ISODateString
  startDate: ISODateString
  endDate: ISODateString
  startIdx: number
  endIdx: number
  length: number

  // create this class object from the API response "data" object
  constructor(from: any = null) {
    if (from) {
      this.isPeriodic = from.isPeriodic
      this.interval = from.interval
      this.key = from.key
      this.name = from.name
      this.asOfDate = from.asOfDate
      this.startDate = from.startDate
      this.endDate = from.endDate
      this.startIdx = from.startIdx
      this.endIdx = from.endIdx
      this.length = from.length
    }
  }

  toString(): string {
    return `${this.name ? this.name[0] : "not initialized"}`
  }
}

export class TermsList {
  periodic: List<Term>
  ranking: List<Term>
}

// maps to the JSON of the /meta/terms API
export class MetaTerms {
  periodic: {
    daily: List<Term>
    monthly: List<Term>
    quarterly: List<Term>
    annual: List<Term>
    names: List<string>
  }
  ranking: {
    daily: List<Term>
    monthly: List<Term>
    quarterly: List<Term>
    annual: List<Term>
    names: List<string>
  }
  toString(): string {
    const termsToString = (terms) =>
      `daily:${terms?.daily}, monthly:${terms?.monthly}, quarterly:${terms?.quarterly}, annual:${terms?.annual}, names:${terms?.names}`
    return `periodic[${termsToString(this.periodic)}] ranking:${termsToString(this.ranking)}`
  }
}
